export default __webpack_public_path__ + "static/media/verified-icon.8eeee189.svg";